import { isEmpty } from 'lodash';
import { ActivitySquare } from 'lucide-react';
import { useRouter } from 'next/router';

import { RatesListRow } from '@/components/modules/rates/list-row';
import { useSavedItems } from '@/hooks/use-saved-items';
import { RATES_MARKET_URL, SAVED_ITEM_TYPE } from '@/lib/constants';
import { MarketRateQueryModel } from '@/lib/models/rates/types';

import { DashboardCard } from '../card';
import { DashboardEmpty } from '../empty';

const DashboardSavedRates = () => {
  const router = useRouter();

  const { savedItems } = useSavedItems({ types: [SAVED_ITEM_TYPE.MARKET_RATE] });

  const sortedSavedItems = (savedItems || []).sort((a, b) => {
    return new Date(a.createdAt || '').valueOf() - new Date(b.createdAt || '').valueOf();
  });
  const hasItems = !isEmpty(sortedSavedItems);

  const handleRateRowClick = () => {
    router.push(RATES_MARKET_URL);
  };

  return (
    <DashboardCard
      title="Market index rates"
      icon={<ActivitySquare />}
      ctaHref={hasItems ? RATES_MARKET_URL : ''}
      ctaText="Manage your watched rates"
    >
      {hasItems && (
        <ul>
          {sortedSavedItems.map((item) => {
            const dataObject = item.data as MarketRateQueryModel;
            if (!dataObject || !dataObject.ports) return null;

            return (
              <div key={item.id}>
                <RatesListRow variant="compact" rateQuery={dataObject} onRowClick={handleRateRowClick} />
              </div>
            );
          })}
        </ul>
      )}
      {!hasItems && (
        <DashboardEmpty
          title="You have no saved market rates"
          cta="Explore Market index rates"
          href={RATES_MARKET_URL}
        />
      )}
    </DashboardCard>
  );
};

export { DashboardSavedRates };
